var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.38,
    height: 50.38,
    viewBox: "0 0 50.38 50.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Streams_Icon",
    "data-name": "Streams Icon",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M5759.383,6804.617s2.589-23.307,20.6-22.953c0,0-16.6-2.476-22.248,11.475l-4.59-2.764Z",
    transform: "translate(-5753.145 -6774.146)",
    fill: "#8bc500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M6097.184,6655.651s23.415,1.274,24.075,19.275c0,0,1.539-16.709-12.708-21.567l2.5-4.738Z",
    transform: "translate(-6078.633 -6648.621)",
    fill: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M6202.2,7007.953s-2.591,23.308-20.6,22.954c0,0,16.6,2.477,22.247-11.475l4.591,2.765Z",
    transform: "translate(-6158.055 -6988.044)",
    fill: "#fa9f22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M5900.844,7114.178s-23.416-1.274-24.076-19.275c0,0-1.539,16.71,12.708,21.566l-2.5,4.739Z",
    transform: "translate(-5869.016 -7070.828)",
    fill: "#7b7b7b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamsIcon);
export default __webpack_public_path__ + "static/media/StreamsIcon.b92ccf06bc21d7403b220c617454671a.svg";
export { ForwardRef as ReactComponent };